import { NavItem } from '@/models/app-nav';
import { UserData } from '@/models/user-data.model';
import { Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  isVisible = signal<boolean>(this.getInitialState());
  userNav = signal<MenuItem[] | null>(null);

  toggleVisibility() {
    const newValue = !this.isVisible();
    this.isVisible.set(newValue);
    localStorage.setItem('sidebarState', JSON.stringify(newValue));
  }

  private getInitialState() {
    const storageState = localStorage.getItem('sidebarState');
    return storageState ? JSON.parse(storageState) : true;
  }

  private transformToMenuItems(appNavItems: any[]): MenuItem[] {
    // Group items by category
    const groupedByCategory = appNavItems.reduce((acc, item) => {
      const category = item.navCategories.navCategoryName;
      if (!acc[category]) {
        acc[category] = {
          label: category,
          icon: item.navCategories.icon,
          items: []
        };
      }
      
      acc[category].items.push({
        label: item.label,
        icon: item.icon,
        routerLink: [item.link]
      });
      
      return acc;
    }, {});

    // Convert the grouped object to an array
    return Object.values(groupedByCategory);
  }

  populateMenu(result: UserData) {
    // Extract the appNav items from the result object
    const appNavItems = result.UserRoles?.flatMap(role => role.PermRoles.roleAppNav.map(ran => ran.appNav));

    if (appNavItems) {
      // Remove duplicates
      const uniqueAppNavItems = appNavItems.filter((item, index, self) =>
        index === self.findIndex((t) => (
          t.appNavId === item.appNavId
        ))
      );

      // Transform the items into the menu structure
      const menuitems = this.transformToMenuItems(uniqueAppNavItems);
      this.userNav.set(menuitems);
    }
  }
}
